/* jshint ignore:start */
jQuery.fn.imageResponsive = function () {
  return this.each(function () {
    const img = jQuery(this).find("img"),
            defaultWidth = img.prop('naturalWidth'),
            defaultHeight = img.prop('naturalHeight'),
            parentHeight = jQuery(this).height(),
            parentWidth = jQuery(this).width(),
            aspectRatio = defaultWidth / defaultHeight;
    img.css({
      "height": "auto",
      "width": "100%",
      "margin-left": "0px",
      "max-width": "inherit"
    });
    var imgHeight = parentWidth / aspectRatio;
    var imgTop = (imgHeight - parentHeight) / 2;
    img.css({
      "margin-top": "-" + imgTop + "px"
    });
    if (img.height() < parentHeight) {
      img.css({
        "height": "100%",
        "width": "auto"
      });
      var right_margin = (img.width() - parentWidth) / 2;
      img.css({
        "margin-left": "-" + right_margin + "px",
        "margin-top": "0"
      });
    } else if (img.width() < parentWidth) {
      img.css({
        "height": "auto",
        "width": "100%",
        "margin-left": "0"
      });
      img.css({
        "margin-top": "-" + imgTop + "px"
      });
    }
  });
};

jQuery.fn.sameHeight = function () {
  var maxHeight = 0;
  return this.each(function (index, elem) {
    jQuery(elem).height('auto');
    var boxHeight = jQuery(elem).height();
    maxHeight = Math.max(maxHeight, boxHeight);
  }).height(maxHeight);
};

function detectIE9() {
  var isIE = document.all && document.addEventListener && !window.atob;
  if (isIE) {
    var sel = document.getElementsByTagName('body');
    sel[0].className += "ie9";
    alert('You are using an outdated browser. Please upgrade your browser to improve your experience.');
  }
}

detectIE9();

/**
 * custom columns in column-wrapper.
 **/
function addParentToCols() {
  if (jQuery('.custom-columns').length > 0) {
    jQuery('.custom-columns').each(function () {
      var $count = jQuery(this).find('.col-hidden').text();  //get column count here;
      var $cols = jQuery(this).find('.col');
      for (var i = 0; i < $cols.length; i += $count) {
        var $div = jQuery("<div/>", {
          class: 'column-wrapper'
        });
        $cols.slice(i, i + $count).wrapAll($div);
      }
    });
  }
}

/**
 * columns-count in column-wrapper.
 **/
function initColCounter() {
  jQuery('.column-wrapper').each(function () {
    var col = jQuery(this).find('.col');
    col.addClass('column-' + col.length);
  });
}

var url;

jQuery(document).ready(function () {

  //on login error open member login overlay
  if (jQuery('.error-message .alert').hasClass('show')) {
    jQuery('body').addClass('stop-overlay');
    jQuery('header .overlay-open > a').addClass('overlay-active');
    jQuery('.overlay-form').css({'display': 'block', 'z-index': '12'}).animate({'opacity': '1'});
  }
  //get vimeo video info
  if (jQuery('.id').length > 0) {
    jQuery('.id').each(function() {
      var url = jQuery(this).text();
      getVimeoThumbnail(url);
    });
  }

  //get youtube video info
  if (jQuery('.yid').length > 0) {
    jQuery('.yid').each(function() {
      var url = jQuery(this).text();
      getYouTubeThumbnail(url);
    });
  }

//add class on base of third level page
  if (jQuery('section').hasClass('banner-third')) {
    jQuery('header').addClass('white-bg');
  }

//  Replace first intro-block h3 to h2
  if (jQuery('.intro-block h3').length > 0) {
    var $firstheader = jQuery('.intro-block h3:eq(0)');
    var $headerContent = $firstheader.html();
    setTimeout(function () {
      jQuery('.intro-block h3').css({opacity: '1'});
    }, 50);
    $firstheader.parents().find('.intro-block:eq(0)').addClass('intro-first');
    $firstheader.replaceWith(jQuery('<h2></h2>').html($headerContent));
  }

  addParentToCols();
  initColCounter();
  jQuery('.hero-banner .bg-img').imageResponsive();
  jQuery('.random-img .bg-img.active').imageResponsive();

  jQuery('.blog-overlay .slide-item').imageResponsive();

  //dashboard template
  jQuery('.your-block').sameHeight();
  jQuery('.historybtn .col').sameHeight();
  msieversion();

//pass parameter for map
  var trail_solution = jQuery('a[href="' + "/explore-imba/trail-creation-and-enhancement/trail-solutions" + '"]');
  jQuery(trail_solution).each(function () {
    jQuery(this).attr('href', "/explore-imba/trail-creation-and-enhancement/trail-solutions?param=trail-solutions-project");
  });

  var ride = jQuery('a[href="' + "/engage/find-your-local-group" + '"]');
  jQuery(ride).each(function () {
    jQuery(this).attr('href', "/engage/find-your-local-group?param=chapter");
  });

  var epics = jQuery('a[href="' + "/ride/where-to-ride/imba-epics" + '"]');
  jQuery(epics).each(function () {
    jQuery(this).attr('href', "/ride/where-to-ride/imba-epics?param=epics");
  });

  jQuery('.sponsor-grid .logo-container').each(function () {

    var col = jQuery(this).find('.col').length;
    if (col > 5) {
      jQuery(this).addClass('text-left');
    }
  });

  var windowWidth = jQuery(window).width();
  if (windowWidth > 595) {
    jQuery('.sponsor-grid .logo-container .col').sameHeight();
  }
  else {
    jQuery('.sponsor-grid .logo-container .col').css('height', 'auto');
  }

  var form = document.getElementsByClassName("webform-submission-resources-form-add-form")[0];
  if (form) {
    form.submit();
  }

});

function msieversion()
        /* Add class on Internet Explore*/
        {
          var ua = window.navigator.userAgent;
          var msie = ua.indexOf("MSIE ");

          if (msie > 0)
          {
            jQuery('html').addClass('ie-all');
          }
          var trident = ua.indexOf('Trident/');
          if (trident > 0) {
            jQuery('html').addClass('ie-all');
          }
          var edge = ua.indexOf('Edge/');
          if (edge > 0) {
            jQuery('html').addClass('ie-all');
          }

          return false;
        }

jQuery(window).resize(function () {
  jQuery('.hero-banner .bg-img').imageResponsive();
//  jQuery('.banner-second .bg-img').imageResponsive();
  jQuery('.random-img .bg-img.active').imageResponsive();

  jQuery('.blog-overlay .slide-item').imageResponsive();

//dashboard template
  jQuery('.your-block').sameHeight();
  jQuery('.historybtn .col').sameHeight();
  jQuery('.ie-all .content-with-grid .bg-img,.ie-all .cta-block .bg-img,.ie-all .grid-blog .bg-img,.ie-all .grid-block .bg-img').imageResponsive();


  var windowWidth = jQuery(window).width();
  if (windowWidth > 595) {
    jQuery('.sponsor-grid .logo-container .col').sameHeight();
  }
  else {
    jQuery('.sponsor-grid .logo-container .col').css('height', 'auto');
  }

});
jQuery(window).resize(function () {
  setTimeout(function () {
    jQuery('.ie-all .content-with-grid .bg-img,.ie-all .cta-block .bg-img,.ie-all .grid-blog .bg-img,.ie-all .grid-block .bg-img,.ie-all .hero-banner .bg-img,.ie-all .column-two-grid  .img-wrapper .bg-img,.ie-all .landing-slider .bg-img,.ie-all .ref-resource .bg-img,.ie-all .blog-detail .bg-img,.ie-all .feature-block .bg-img,.ie-all .video-section .bg-img,.ie-all .resources-guidline .bg-img').imageResponsive();
  }, 100);
});

jQuery(window).bind("load scroll resize", function () {
  var $winHeight = jQuery(window).height();
  var $winTop = jQuery(window).scrollTop();
  var $animationDelay = 0.3;

  /*
   * Animations prototype to apply keyframe animations defined in css/scss
   * @param {String} elem = Target elememt/selector
   * @param {String} animation = Animation keyframe name as defined in css/scss
   * @param {Number} time = Animation delay time (in milliseconds(ms))
   * @param {Boolean} counter = Increase delay with increase in index/elem/counter(True/False)
   */
  function animationPrototype(elem, animation, time, counter) {
    if (counter === undefined) {
      counter = false;
    }
    if (jQuery(elem).length > 0) {
      jQuery(elem).each(function (index, elem) {
        var animationTime;
        if (counter) {
          animationTime = $animationDelay * (index + 1);
        } else {
          animationTime = time;
        }
        var $offset = jQuery(this).parent().offset().top;
        var $secHeight = jQuery(this).parent().outerHeight();
        var $secPosition = $offset - $winTop;
        if (($secPosition <= ($winHeight - 150)) && ($secPosition > -500)) {
          if (!jQuery(this).hasClass('ie9')) {
            jQuery(this).css({'animation-duration': '1s', 'animation-delay': animationTime + 's', 'animation-name': animation});
          } else {
            jQuery(this).animate({'opacity': '1', 'left': '0'}, animationTime);
          }
        } else if ((($secPosition - 80) >= -($secHeight)) && ($secPosition <= ($winHeight - 150))) {
          //(!jQuery(this).hasClass('ie9')) ? jQuery(this).css({'animation-duration': '1s', 'animation-delay': animationTime + 's', 'animation-name': animation}) : jQuery(this).animate({'opacity': '1', 'left': '0'}, animationTime);
          if (!jQuery(this).hasClass('ie9')) {
            jQuery(this).css({'animation-duration': '1s', 'animation-delay': animationTime + 's', 'animation-name': animation});
          } else {
            jQuery(this).animate({'opacity': '1', 'left': '0'}, animationTime);
          }
        }
      });
    }
  }

  jQuery('section').each(function (index, elem) {
    var sel = jQuery(elem).find('.move-up');
    // Fadein up
    animationPrototype(sel, 'fadeInUp', $animationDelay, true);

    // Fadein from left to right
    animationPrototype('.move-right', 'fadeInRight', 0.5);

    // Fadein from right to left
    animationPrototype('.move-left', 'fadeInLeft', 0.5);
  });
});

//get You-tube Video data
function getYouTubeThumbnail(id) {
  if(id.length > 0) {
    var wrapper_class = 'youtube-wrapper-' + id;
    // Ajax request to get the video details
    jQuery.ajax({
      type: 'GET',
      url: 'https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v='+ id +'&format=json',
      success: function (data) {
        var thumbnail_src = "https://img.youtube.com/vi/" + id + "/maxresdefault.jpg";
        var title = data.title;
        jQuery(".video-section ." + wrapper_class + " h5").text(title);
        jQuery(".video-section ." + wrapper_class + " .youtube-img img").attr('src', thumbnail_src);
        jQuery(".video-section ." + wrapper_class + " .play-video-youtube").attr('data-attr', 'https://www.youtube.com/embed/' + id + '?autoplay=1');
      }
    });
  }
}

//get vimeo video data
function getVimeoThumbnail(id) {
  var wrapper_class = 'vimeo-wrapper-' + id;
  // Ajax request to get the video details
  jQuery.ajax({
    type: 'GET',
    url: 'https://vimeo.com/api/v2/video/' + id + '.json',
    success: function (data) {
      var thumbnail_src = data[0].thumbnail_large;
      var title = data[0].title;
      var vdate = data[0].upload_date;
      var sdate = vdate.split("-");
      var date = sdate[1] + '.' + sdate[2].substr(0, 2) + '.' + sdate[0].substr(2, 4);
      jQuery(".video-section ." + wrapper_class + " .vimeo-img img").attr('src', thumbnail_src);
      jQuery(".video-section ." + wrapper_class + " .play-video").attr('data-attr', 'https://player.vimeo.com/video/' + id + '?autoplay=1');
      jQuery(".video-section ." + wrapper_class + " h5").text(title);
      jQuery(".video-section ." + wrapper_class + " vid_date").text(date);
    }
  });
}

jQuery(window).on("load", function () {
  var winWidth = jQuery(window).width();
  var windowWidth = jQuery(window).width();
  jQuery(window).on("resize", function () {
    if (!(winWidth === windowWidth)) {
      if (jQuery(".ie-all .column-with-cta .background-with-icon .bg-img").length) {
        jQuery(".ie-all .column-with-cta .background-with-icon .bg-img").each(function () {
          var img = jQuery(this).children("img"),
                  parentHeight = jQuery(this).height(),
                  parentWidth = jQuery(this).width();
          img.css({"height": "auto", "width": "100%", "margin-left": "0px"});
          if (img.height() < parentHeight) {
            img.css({"height": "100%", "width": "auto"});
            var right_margin = (img.width() - parentWidth) / 2;
            img.css({"margin-left": "-" + right_margin + "px"});
          } else if (img.width() < parentWidth) {
            img.css({"height": "auto", "width": "100%", "margin-left": "0"});
          }
        });
      }
    }
    winWidth = jQuery(window).width();
  }).resize();
});
